<template>
  <el-row :gutter="20" class="image-uploader">
    <el-col :span="12" class="image-uploader__inner">
      <div class="image-uploader__content">
        <p class="image-uploader__title">Upload an image</p>
        <div v-if="imageSrc" class="image-uploader__wrap-upload-img">
          <div class="image-uploader__preview-content">
            <span class="delete-icon" @click="handleDeleteImage">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <div class="image-uploader__wrap-img">
              <img class="el-upload-list__item-thumbnail" :src="getUrlImage()" alt="" />
            </div>

            <!-- <img v-if="selectedFile && selectedFile.url" :src="selectedFile.url" alt=""> -->
            <!-- <div class="wrap-delete-img">

            </div> -->
          </div>
        </div>
        <el-upload v-else class="upload-demo" action="#" list-type="picture" :auto-upload="false" :drag="true"
          :multiple="false" :on-change="onChangeHandler" accept="image/*">
          <div class="image-uploader__upload" slot="default">
            <div>
              <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M35 24V26.2C35 29.2803 35 30.8204 34.4005 31.9969C33.8732 33.0318 33.0318 33.8732 31.9969 34.4005C30.8204 35 29.2803 35 26.2 35H10.8C7.71971 35 6.17957 35 5.00305 34.4005C3.96816 33.8732 3.12677 33.0318 2.59946 31.9969C2 30.8204 2 29.2803 2 26.2V24M27.6667 11.1667L18.5 2M18.5 2L9.33333 11.1667M18.5 2V24"
                  stroke="#3CADFF" stroke-width="3.66667" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <span>Drag an image to upload <br />or</span>
            <el-button>Browse Files</el-button>
            <span>Supported file types: <strong>JPG and PNG</strong></span>
          </div>
        </el-upload>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    isReview: { type: Boolean, default: false },
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions('readAlouds', ['changeImageUploadReadAloud']),
    onChangeHandler(file) {
      if (file) {
        setTimeout(() => {
          // this.selectedFile = file;
          // const url = URL.createObjectURL(file.raw);
          this.changeImageUploadReadAloud(file)
        }, 100)
      }
    },
    handleDeleteImage() {
      this.changeImageUploadReadAloud(null)
    },
    getUrlImage() {
      if (!this.imageUpload || !this.imageUpload.raw) return ''
      return URL.createObjectURL(this.imageUpload.raw);
    }
  },
  computed: {
    ...mapState('readAlouds', ['imageUpload']),
    imageSrc() {
      if (!this.imageUpload || !this.imageUpload.url) return ''
      return this.imageUpload.url
    }
  }
};
</script>

<style lang="scss" scoped>
.image-uploader {
  padding-right: 20px;

  &__content {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  &__title {
    font-size: 17px;
    font-style: normal;
    font-weight: 510;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-bottom: 12px;
  }

  &__upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-items: center;
    gap: 12px;
    height: 100%;
  }

  .upload-demo {
    height: 264px;
  }

  &__preview {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;

    border: 1px solid#E6E6E6;
    border-radius: 8px;
  }

  &__wrap-upload-img {
    overflow: hidden;
    position: relative;
    display: flex;
    border-radius: 8px;
    border: 1px solid #e6e6e6ac;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
  }


  &__preview-content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 396px;
    height: 264px;
    border: 1px solid#E6E6E6;
    border-radius: 8px;
  }

  &__wrap-img {
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;

    img {
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }

  &__inner {
    .delete-icon {
      position: absolute;
      top: -12px;
      right: -12px;
      height: 24px;
      width: 24px;
      background-color: #DA615C;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }


  .el-upload-list {
    &__item-thumbnail {
      // height: 100%;
      width: 100%;
      height: auto;
    }
  }

  ::v-deep .el-upload {
    width: 100%;
  }

  ::v-deep .el-upload-dragger {
    min-height: 300px;
    border: 1px solid#E6E6E6;
    width: 100%;
    padding: 70px;
  }

  ::v-deep .el-upload {
    width: 100%;

  }

  // ::v-deep .el-upload-list {
  //   display: none;
  // }
}
</style>
